(ns rothko.theme.manatee.form2.slider)

(def slider-group-input
  {:valid
   {:valid-points-color :green}})
